// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { V1RaftCheckMemberStatusString } from './V1RaftCheckMemberStatusString';
import {
  V1RaftCheckMemberStatusStringFromJSON,
  V1RaftCheckMemberStatusStringFromJSONTyped,
  V1RaftCheckMemberStatusStringToJSON,
  V1RaftCheckMemberStatusStringToJSONTyped,
} from './V1RaftCheckMemberStatusString';

/**
 *
 * @export
 * @interface V1RaftStatusMember
 */
export interface V1RaftStatusMember {
  /**
   *
   * @type {string}
   * @memberof V1RaftStatusMember
   */
  address?: string;
  /**
   *
   * @type {string}
   * @memberof V1RaftStatusMember
   */
  database?: string;
  /**
   *
   * @type {string}
   * @memberof V1RaftStatusMember
   */
  error?: string;
  /**
   *
   * @type {V1RaftCheckMemberStatusString}
   * @memberof V1RaftStatusMember
   */
  memberStatus?: V1RaftCheckMemberStatusString;
  /**
   *
   * @type {string}
   * @memberof V1RaftStatusMember
   */
  recognisedLeader?: string;
  /**
   *
   * @type {number}
   * @memberof V1RaftStatusMember
   */
  recognisedLeaderTerm?: number;
  /**
   *
   * @type {boolean}
   * @memberof V1RaftStatusMember
   */
  replicationSuccessful?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof V1RaftStatusMember
   */
  requester?: boolean;
  /**
   *
   * @type {string}
   * @memberof V1RaftStatusMember
   */
  serverId?: string;
  /**
   *
   * @type {string}
   * @memberof V1RaftStatusMember
   */
  serverName?: string;
}

/**
 * Check if a given object implements the V1RaftStatusMember interface.
 */
export function instanceOfV1RaftStatusMember(
  value: object,
): value is V1RaftStatusMember {
  return true;
}

export function V1RaftStatusMemberFromJSON(json: any): V1RaftStatusMember {
  return V1RaftStatusMemberFromJSONTyped(json, false);
}

export function V1RaftStatusMemberFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1RaftStatusMember {
  if (json == null) {
    return json;
  }
  return {
    address: json['address'] == null ? undefined : json['address'],
    database: json['database'] == null ? undefined : json['database'],
    error: json['error'] == null ? undefined : json['error'],
    memberStatus:
      json['memberStatus'] == null
        ? undefined
        : V1RaftCheckMemberStatusStringFromJSON(json['memberStatus']),
    recognisedLeader:
      json['recognisedLeader'] == null ? undefined : json['recognisedLeader'],
    recognisedLeaderTerm:
      json['recognisedLeaderTerm'] == null
        ? undefined
        : json['recognisedLeaderTerm'],
    replicationSuccessful:
      json['replicationSuccessful'] == null
        ? undefined
        : json['replicationSuccessful'],
    requester: json['requester'] == null ? undefined : json['requester'],
    serverId: json['serverId'] == null ? undefined : json['serverId'],
    serverName: json['serverName'] == null ? undefined : json['serverName'],
  };
}

export function V1RaftStatusMemberToJSON(json: any): V1RaftStatusMember {
  return V1RaftStatusMemberToJSONTyped(json, false);
}

export function V1RaftStatusMemberToJSONTyped(
  value?: V1RaftStatusMember | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    address: value['address'],
    database: value['database'],
    error: value['error'],
    memberStatus: V1RaftCheckMemberStatusStringToJSON(value['memberStatus']),
    recognisedLeader: value['recognisedLeader'],
    recognisedLeaderTerm: value['recognisedLeaderTerm'],
    replicationSuccessful: value['replicationSuccessful'],
    requester: value['requester'],
    serverId: value['serverId'],
    serverName: value['serverName'],
  };
}
